module.exports = __webpack_public_path__ + "img/mickey115.77e05736.jpg";